var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "app-card"
    },
    [
      _c("gg-card-header", [_vm._v(" Social Media ")]),
      _c(
        "gg-card-text",
        {
          staticClass: "pa-4"
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-form",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                attrs: {
                                  label: "Facebook Link",
                                  name: "facebook",
                                  outlined: "",
                                  autocomplete: "new-password",
                                  "data-vv-as": "Facebook Link",
                                  "error-messages": _vm.errors.collect(
                                    "facebook"
                                  )
                                },
                                model: {
                                  value: _vm.facebook,
                                  callback: function callback($$v) {
                                    _vm.facebook = $$v
                                  },
                                  expression: "facebook"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                attrs: {
                                  label: "Twitter Link",
                                  name: "twitter",
                                  outlined: "",
                                  autocomplete: "new-password",
                                  "data-vv-as": "Twitter Link",
                                  "error-messages": _vm.errors.collect(
                                    "twitter"
                                  )
                                },
                                model: {
                                  value: _vm.twitter,
                                  callback: function callback($$v) {
                                    _vm.twitter = $$v
                                  },
                                  expression: "twitter"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                attrs: {
                                  label: "Instagram Link",
                                  name: "instagram",
                                  outlined: "",
                                  autocomplete: "new-password",
                                  "data-vv-as": "Instagram Link",
                                  "error-messages": _vm.errors.collect(
                                    "instagram"
                                  )
                                },
                                model: {
                                  value: _vm.instagram,
                                  callback: function callback($$v) {
                                    _vm.instagram = $$v
                                  },
                                  expression: "instagram"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                attrs: {
                                  label: "Pinterest Link",
                                  name: "pinterest",
                                  outlined: "",
                                  autocomplete: "new-password",
                                  "data-vv-as": "Pinterest Link",
                                  "error-messages": _vm.errors.collect(
                                    "pinterest"
                                  )
                                },
                                model: {
                                  value: _vm.pinterest,
                                  callback: function callback($$v) {
                                    _vm.pinterest = $$v
                                  },
                                  expression: "pinterest"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                attrs: {
                                  label: "LinkedIn Link",
                                  name: "linkedIn",
                                  outlined: "",
                                  autocomplete: "new-password",
                                  "data-vv-as": "LinkedIn Link",
                                  "error-messages": _vm.errors.collect(
                                    "linkedIn"
                                  )
                                },
                                model: {
                                  value: _vm.linkedIn,
                                  callback: function callback($$v) {
                                    _vm.linkedIn = $$v
                                  },
                                  expression: "linkedIn"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }